import api from './index';
import axios from 'axios';

// Create a separate client for public API
const publicApi = axios.create({
  baseURL: 'https://suitupapi.club',
  headers: {
    'Accept': 'public api; version=1',
    'Content-Type': 'application/json'
  }
});

const jobsAPI = {
  // Get all job titles
  getJobTitles: (config = {}) => {
    return api.get('/job_titles', {
      headers: {
        'Accept': 'shared api; version=1'
      },
      ...config
    });
  },
  
  // Get offers (optionally filtered by job titles) with pagination
  getOffers: (jobTitleIds = null, page = 1, perPage = 20, config = {}) => {
    let url = '/applicants/offers';
    let params = new URLSearchParams();
    
    // Add pagination parameters
    params.append('page', page);
    params.append('per', perPage);
    
    // Add sorting by ID descending (using rebase server standard format)
    params.append('sort', '-id');
    
    // Add job title filter if provided
    if (jobTitleIds && jobTitleIds.length > 0) {
      params.append('job_title_ids', jobTitleIds.join(','));
    }
    
    // Append query parameters to URL
    url += `?${params.toString()}`;
    
    return api.get(url, config);
  },
  
  // Get single offer details
  getOffer: (offerId) => {
    return api.get(`/applicants/offers/${offerId}?include_type=swipe`);
  },
  
  // Get detailed position information from public API (like the website does)
  getPositionDetails: (positionId) => {
    return publicApi.get(`/positions/${positionId}`);
  },
  
  // Apply to an offer
  applyToOffer: (offerId) => {
    return api.put(`/applicants/offers/${offerId}`, {
      status: 'accepted'
    });
  }
};

export default jobsAPI;
